import {Component, Inject, OnInit, PLATFORM_ID, ViewContainerRef} from '@angular/core';
import * as moment from 'moment';
import {GoogleAnalyticsService} from './services/google-analytics/google-analytics.service';
import {Store} from '@ngrx/store';
import {Title} from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {filter} from 'rxjs/operators';
import {GetBijbEventsAction} from './ngrx/actions/bijb-event/get-events-action';
import {CurrentAccountState} from './ngrx/states/current-account-state';
import {GetCurrentAccountAction} from './ngrx/actions/current-account/get-current-account-action';
import {BijbEventsState} from './ngrx/states/bijb-events-state';
import { register } from 'swiper/element/bundle';
import { isPlatformBrowser } from '@angular/common';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  fab,
  faFacebook,
  faInstagram,
  faLinkedin,
  faPinterest
} from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import {
  fas,
  faArrowCircleRight,
  faBan,
  faBars,
  faCalendarAlt,
  faCamera,
  faCar,
  faCheck,
  faCheckCircle,
  faClock,
  faCocktail,
  faCog,
  faCommentDots,
  faComments,
  faCopy,
  faCrown,
  faDotCircle,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faFileUpload,
  faFlask,
  faGift,
  faHiking,
  faHome,
  faInfinity,
  faKeyboard,
  faList,
  faLock,
  faMapMarkerAlt,
  faMobileAlt,
  faPencilAlt,
  faPhoneAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faQrcode,
  faRunning,
  faSave,
  faShoppingBasket,
  faSignOutAlt,
  faSyncAlt,
  faSkiing,
  faSortDown,
  faStar,
  faTasks,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUsers,
  faWalking
} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, RouterOutlet, FontAwesomeModule]
})
export class AppComponent implements OnInit {
  /* vcRef seems unsued, but is used by ngx-color-picker */

  // noinspection JSUnusedGlobalSymbols
  constructor(private googleAnalyticsService: GoogleAnalyticsService,
              @Inject(PLATFORM_ID) private platformId: Object,
              private currentAccountStateStore: Store<CurrentAccountState>,
              private bijbEventsStateStore: Store<BijbEventsState>,
              public vcRef: ViewContainerRef,
              private titleService: Title,
              private router: Router,
              private route: ActivatedRoute,
              private library: FaIconLibrary) {
    if (isPlatformBrowser(platformId)) {
     register();
     this.googleAnalyticsService.init();
    }
    this.addIcons();
    this.currentAccountStateStore.dispatch(new GetCurrentAccountAction());
    this.bijbEventsStateStore.dispatch(new GetBijbEventsAction());
  }

  private static setMomentLocale(): void {
    moment.locale('nl');
    moment.updateLocale('nl', {
      monthsShort: [
        'jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
        'jul', 'aug', 'sep', 'okt', 'nov', 'dec'
      ]
    });
  }

  public ngOnInit(): void {
    AppComponent.setMomentLocale();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.getChildTitle(this.route).then(title => {
        this.titleService.setTitle(title);
      }, () => {
      });
    });
  }

  private getChildTitle(route: ActivatedRoute): Promise<string> {
    if (route.firstChild) {
      return this.getChildTitle(route.firstChild).then(title => {
        return title;
      }, () => {
        return this.getTitle(route);
      });
    } else {
      return this.getTitle(route);
    }
  }

  private getTitle(route: ActivatedRoute): Promise<string> {
    return new Promise((resolve, reject) => {
      route.data.subscribe(data => {
        if (data.title) {
          resolve(data.title);
        } else {
          reject('no data');
        }
      });
    });
  }

  private addIcons(): void {
    this.library.addIconPacks(fas, far, fab);
    this.library.addIcons(
      faArrowCircleRight,
      faBan,
      faBars,
      faCalendarAlt,
      faCamera,
      faCar,
      faCheck,
      faCheckCircle,
      faClock,
      faCocktail,
      faCog,
      faCommentDots,
      faComments,
      faCopy,
      faCrown,
      faDotCircle,
      faEnvelope,
      faEnvelopeOpen,
      faExclamationTriangle,
      faExternalLinkSquareAlt,
      faFacebook,
      faFileUpload,
      faFlask,
      faGift,
      faHiking,
      faHome,
      faInfinity,
      faInstagram,
      faKeyboard,
      faLinkedin,
      faList,
      faLock,
      faMapMarkerAlt,
      faMobileAlt,
      faPencilAlt,
      faPhoneAlt,
      faPinterest,
      faPlay,
      faPlus,
      faPlusCircle,
      faQrcode,
      faRunning,
      faSave,
      faShoppingBasket,
      faSignOutAlt,
      faSyncAlt,
      faSkiing,
      faSortDown,
      faStar,
      faTasks,
      faThumbsUp,
      faTimes,
      faTimesCircle,
      faTrashAlt,
      faUser,
      faUsers,
      faWalking
    );
  }
}
